export default __webpack_public_path__ + "static/media/ph_info.8824eb7e.svg";